@if (skills?.length > 0) {
  <div class="skills-content">
    <h2>Skills</h2>
    @for (item of skills; track $index) {
      <h3>{{ item.category }}</h3>
      @if (item.category === 'AI Skills') {
        @for (skill of item.skills; track skill) {
          <div class="skills-item">
            <div class="skill-item-left">
              @if (isAiSkillNameView) {
                <label class="skill-title">
                  {{ skill.skill }}</label
                  >
              }
              @if (isAiYearsExpView) {
                <label class="skill-year"
                  >{{ skill?.yearOfExperience }} @if(skill?.yearOfExperience < 2){ year }
                  @else{ years }</label
                  >
              }
              </div>
              @if (isAiProficiencyView) {
                <div class="skill-item-right">
                  <nz-rate [nzAllowHalf]="false" [ngModel]="skill.proficiencyRate" [nzDisabled]="true" />
                  <label>{{ skill.proficiencyLabel }}</label>
                </div>
              }
          </div>
          @if (isAiDescriptionView && skill.description) {
            <div class="skill-description">
              <div [innerHTML]="skill.description" class="tinymce"></div>
            </div>
          }
        }
      } @else {
        @for (skill of item.skills; track skill) {
          <div class="skills-item">
            <div class="skill-item-left">
              @if (isSkillNameView) {
                <label class="skill-title">
                  {{ skill.skill }}</label
                  >
              }
              @if (isYearsExpView) {
                <label class="skill-year"
                  >{{ skill?.yearOfExperience }} @if(skill?.yearOfExperience < 2){ year }
                  @else{ years }</label
                  >
              }
              </div>
              @if (isProficiencyView) {
                <div class="skill-item-right">
                  <nz-rate [nzAllowHalf]="false" [ngModel]="skill.proficiencyRate" [nzDisabled]="true" />
                  <label>{{ skill.proficiencyLabel }}</label>
                </div>
              }
          </div>
          @if (skill.description) {
            <div class="skill-description">
              <div [innerHTML]="skill.description" class="tinymce"></div>
            </div>
          }
        }
      }
    }
  </div>
}
